import AdditionalUsersFilters from 'components/UsersList/AdditionalUsers/AdditionalUsersFilters';
import AdditionalUsersHeaderButtons from 'components/UsersList/AdditionalUsers/AdditionalUsersHeaderButtons';
import AdditionalUsersHeaders from 'components/UsersList/AdditionalUsers/AdditionalUsersHeaders';
import AdditionalUserTableRow from 'components/UsersList/AdditionalUsers/AdditionalUserTableRow';
import AllUsersFilters from 'components/UsersList/AllUsers/AllUsersFilters';
import AllUsersHeaderButtons from 'components/UsersList/AllUsers/AllUsersHeaderButtons';
import AllUsersHeaders from 'components/UsersList/AllUsers/AllUsersHeaders';
import AllUserTableRow from 'components/UsersList/AllUsers/AllUserTableRow';
import LLUsersFilters from 'components/UsersList/LLUsers/LLUsersFilters';
import LLUsersHeaderButtons from 'components/UsersList/LLUsers/LLUsersHeaderButtons';
import LLUsersHeaders from 'components/UsersList/LLUsers/LLUsersHeaders';
import LLUserTableRow from 'components/UsersList/LLUsers/LLUserTableRow';
import MonitoredUsersFilters from 'components/UsersList/MonitoredUsers/MonitoredUsersFilters';
import MonitoredUsersHeaderButtons from 'components/UsersList/MonitoredUsers/MonitoredUsersHeaderButtons';
import MonitoredUsersHeaders from 'components/UsersList/MonitoredUsers/MonitoredUsersHeaders';
import MonitoredUserTableRow from 'components/UsersList/MonitoredUsers/MonitoredUserTableRow';
import { User } from 'types';

type TableRowProps = {
  user: User;
  selectedUsers: User[];
  handleSelectUser: (event: React.ChangeEvent<HTMLInputElement>, user: User) => void;
};

type UserType = {
  headerButtons: React.FC;
  filters: React.FC;
  headers: React.FC;
  tableRow: React.FC<TableRowProps>;
  colCount: number;
};

const userTypeMap: Record<string, UserType> = {
  'monitored-users': {
    headerButtons: MonitoredUsersHeaderButtons,
    filters: MonitoredUsersFilters,
    headers: MonitoredUsersHeaders,
    tableRow: MonitoredUserTableRow,
    colCount: 7,
  },
  'll-users': {
    headerButtons: LLUsersHeaderButtons,
    filters: LLUsersFilters,
    headers: LLUsersHeaders,
    tableRow: LLUserTableRow,
    colCount: 6,
  },
  'additional-users': {
    headerButtons: AdditionalUsersHeaderButtons,
    filters: AdditionalUsersFilters,
    headers: AdditionalUsersHeaders,
    tableRow: AdditionalUserTableRow,
    colCount: 4,
  },
  'all-users': {
    headerButtons: AllUsersHeaderButtons,
    filters: AllUsersFilters,
    headers: AllUsersHeaders,
    tableRow: AllUserTableRow,
    colCount: 4,
  },
};

export default userTypeMap;
